﻿import './tracker.config';

import TKModuleFactory from '@tk/utilities/tk.module.factory';
import TKManager from '@tk/basics/tk.manager';
import TKButtonDropdown from '@tk/controls/tk.button.dropdown';
import TKNavigationSidebar from '@tk/components/tk.navigation.sidebar';
import TKHeader from '@tk/components/tk.header';
import TKViewport from '@tk/basics/tk.viewport';
import TKSearch from '@tk/controls/tk.search';
import TKBasketButton from '@tk/components/tk.basket.button';
import TKContextMenu from '@tk/components/tk.context.menu';
import TKFlag from '@tk/components/tk.flag';
import TKMinibasket from '@tk/components/tk.minibasket';
import TKProductTile from '@tk/components/tk.product.tile';
import TKProductVariants from '@tk/components/tk.product.variants';
import TKTooltip from '@tk/components/tk.tooltip';
import TKDialog from '@tk/components/tk.dialog';
import TKFilter from '@tk/components/tk.filter';
import TKFilterChip from '@tk/components/tk.filter.chip';
import TKFilterResult from '@tk/components/tk.filter.result';
import TKFilterDropdown from '@tk/components/tk.filter.dropdown';
import TKFilterGroupWrapper from '@tk/components/tk.filter.group.wrapper';
import TKFilterGroup from '@tk/components/tk.filter.group';
import TKFilterSearch from '@tk/components/tk.filter.search';
import TKFilterSelectReset from '@tk/components/tk.filter.select.reset';
import TKFilterDrilldownButton from '@tk/components/tk.filter.drilldown.button';
import TKArticleList from '@tk/components/tk.article.list';
import TKPrice from '@tk/components/tk.price';
import TKStock from '@tk/components/tk.stock';
import TKTabsTab from '@tk/controls/tk.tabs.tab';
import TKFavoriteButton from '@tk/components/tk.favorite.button';
import TKFormElement from '@tk/controls/tk.form.element';
import TKFormValidator from '@tk/controls/tk.form.validator';
import TKFavoriteInfo from '@tk/components/tk.favorite.info';
import TKTabsAccordion from '@tk/controls/tk.tabs.accordion';
import TKCompareButton from '@tk/components/compare/tk.compare.button';
import TKCarousel from '@tk/components/tk.carousel';
import TKArticleListSort from '@tk/components/tk.article.list.sort';
import TKArticleListLayoutSwitch from '@tk/components/tk.article.list.layout.switch';
import TKBreadcrumb from '@tk/components/tk.breadcrumb';
import TKFormRangeslider from '@tk/controls/tk.form.rangeslider';
import TKSelection from '@tk/controls/tk.selection';
import TKCompareInfo from '@tk/components/compare/tk.compare.info';
import TKFormDatepicker from '@tk/controls/tk.form.datepicker';
import TKFormTimepicker from '@tk/controls/tk.form.timepicker';
import TCSubmitDirect from '@/controls/tc.submit.direct';
import TCSectionToggler from '@/components/tc.section.toggler';
import TKTracker from '@tk/components/tracker/tk.tracker';
import TKTracking from '@tk/components/tracker/tk.tracking';
import TCSpareDialog from './components/tc.spare.dialog';
import TKFileUploadArea from '@tk/controls/tk.file.upload.area';
import TKCompareStore from '@tk/components/compare/tk.compare.store';
import { configureStore } from '@tk/utilities/tk.use.store';

import 'tippy.js/dist/tippy.css';
import '@splidejs/splide/dist/css/splide.min.css';
import 'flatpickr/dist/flatpickr.min.css';
import '@uppy/dashboard/dist/style.min.css';
import '@uppy/core/dist/style.min.css';
import '@scss/modules/struct.scss';

const compareStore = new TKCompareStore();

configureStore({
    compareStore,
});
export default class Struct extends TKModuleFactory {
    constructor() {
        super([
            { name: 'tk-manager', constructor: TKManager },
            { name: 'tk-viewport', constructor: TKViewport },
            { name: 'tk-tracker', constructor: TKTracker },
            { name: 'tk-button-dropdown', constructor: TKButtonDropdown },
            { name: 'tk-header', constructor: TKHeader },
            { name: 'tk-nav-sidebar', constructor: TKNavigationSidebar },
            { name: 'tk-search', constructor: TKSearch },
            { name: 'tk-basket-button', constructor: TKBasketButton },
            { name: 'tk-context-menu', constructor: TKContextMenu },
            { name: 'tk-flag', constructor: TKFlag },
            { name: 'tk-minibasket', constructor: TKMinibasket },
            { name: 'tk-product-tile', constructor: TKProductTile },
            { name: 'tk-product-variants', constructor: TKProductVariants },
            { name: 'tk-tooltip', constructor: TKTooltip },
            { name: 'tk-dialog', constructor: TKDialog },
            { name: 'tk-filter', constructor: TKFilter },
            { name: 'tk-filter-chip', constructor: TKFilterChip },
            { name: 'tk-filter-result', constructor: TKFilterResult },
            { name: 'tk-filter-dropdown', constructor: TKFilterDropdown },
            { name: 'tk-filter-group-wrapper', constructor: TKFilterGroupWrapper },
            { name: 'tk-filter-group', constructor: TKFilterGroup },
            { name: 'tk-filter-search', constructor: TKFilterSearch },
            { name: 'tk-filter-select-reset', constructor: TKFilterSelectReset },
            { name: 'tk-filter-drilldown-button', constructor: TKFilterDrilldownButton },
            { name: 'tk-article-list', constructor: TKArticleList },
            { name: 'tk-price', constructor: TKPrice },
            { name: 'tk-stock', constructor: TKStock },
            { name: 'tk-tabs-tab', constructor: TKTabsTab },
            { name: 'tk-favorite-button', constructor: TKFavoriteButton },
            { name: 'tk-favorite-info', constructor: TKFavoriteInfo },
            { name: 'tk-form-element', constructor: TKFormElement },
            { name: 'tk-form-validator', constructor: TKFormValidator },
            { name: 'tk-tabs-accordion', constructor: TKTabsAccordion },
            { name: 'tk-compare-button', constructor: TKCompareButton },
            { name: 'tk-carousel', constructor: TKCarousel },
            { name: 'tk-article-list-sort', constructor: TKArticleListSort },
            { name: 'tk-article-list-layout-switch', constructor: TKArticleListLayoutSwitch },
            { name: 'tk-breadcrumb', constructor: TKBreadcrumb },
            { name: 'tk-form-range-slider', constructor: TKFormRangeslider },
            { name: 'tk-selection', constructor: TKSelection },
            { name: 'tk-compare-info', constructor: TKCompareInfo },
            { name: 'tk-form-datepicker', constructor: TKFormDatepicker },
            { name: 'tk-form-timepicker', constructor: TKFormTimepicker },
            { name: 'tc-submit-direct', constructor: TCSubmitDirect },
            { name: 'tc-section-toggler', constructor: TCSectionToggler },
            { name: 'tk-tracking', constructor: TKTracking },
            { name: 'tc-spare-dialog', constructor: TCSpareDialog },
            { name: 'tk-file-upload-area', constructor: TKFileUploadArea },
        ]);
    }
}

new Struct();
